import { EventHostsCard } from "./EventHostsCard";

export default EventHostsCard;
